import type { ReactElement } from "react";
import { SearchInput } from "@/components/admin/search-input";

import { useCustomFieldFilterInputs } from "../customFields/customFieldFilterInputs";
import { ChoiceFilter } from "../filters/ChoiceFilter";
import { usePartnerCategoryChoices, usePartnerTypes } from "./partnerTypes";

/** Filters shown in the top bar until the user picks their own. */
export const DEFAULT_PARTNER_FILTERS = ["category@in", "type@in"];

/** Every filter of the partners list; « Ajouter un filtre » shows or hides them. */
export const usePartnerFilters = (): ReactElement[] => {
  const categoryChoices = usePartnerCategoryChoices();
  const types = usePartnerTypes();
  const customFieldFilters = useCustomFieldFilterInputs("partners");

  return [
    <SearchInput key="q" source="q" alwaysOn />,
    <ChoiceFilter
      key="category"
      source="category@in"
      label="resources.partners.fields.category"
      choices={categoryChoices}
    />,
    <ChoiceFilter
      key="type"
      source="type@in"
      label="resources.partners.fields.type"
      choices={types}
    />,
    ...customFieldFilters,
  ];
};
